import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../helpers/ApiHelper';
import { UiHelper } from '../helpers/UiHelper';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as urlParser from 'url-parse';
import * as qs from 'qs';

export class LiveImage extends Component {
  constructor(props) {
    super(props);
    this.updateImageIntervalFnId = null;
    this.imageFeedRefreshInterval = AppConfig.imageFeedRefreshInterval;
    this.state = {
      urlJpeg: this.props.urlJpeg,
    }
  }

  updateImageFeedUrl() {
    let urlJpeg = this.props.urlJpeg;
    if (urlJpeg) {
      const urlParsed = new urlParser(urlJpeg);
      const currQueryString = (urlParsed.query).substring(1);
      const queryParams = qs.parse(currQueryString);
      queryParams.timestamp = moment().valueOf();
      const modifiedQueryString = qs.stringify(queryParams);
      urlJpeg = urlParsed.origin + urlParsed.pathname + '?' + modifiedQueryString;
      this.setState({
        urlJpeg: urlJpeg
      })
    }
  }

  componentDidMount() {
    this.updateImageIntervalFnId = setInterval(() => {
      //console.log("updating live image...")
      this.updateImageFeedUrl();
    }, this.imageFeedRefreshInterval);
  }

  componentWillUnmount() {
    if (this.updateImageIntervalFnId) {
      clearInterval(this.updateImageIntervalFnId);
    }
  }

  render() {
    return (
      <img
        style={{ width: '100%', height: 'auto' }}
        id='target-image'
        src={this.state.urlJpeg}
        alt='Live Image Stream'
      />
    )
  }
}

const Styles = StyleSheet.create({
})



// WEBPACK FOOTER //
// ./src/common/components/LiveImage.js